module.exports = __webpack_public_path__ + "img/OT166.065b743.jpg";